import React, {useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { TableCell, TableRow, Checkbox, Button, Modal } from '@material-ui/core';
import { Link, Announcement} from '@material-ui/icons';
import { FaGoogle } from "react-icons/fa";
import RemarksModal from '../modals/Remarks';
import NewTextModal from '../modals/NewText';
import { resetRemarks } from '../../../store/dcs'
import _ from 'lodash'
import formatPhoneNumber from '../../../utils/formatPhone';
import { markTextsAsOld, fetchNewTexts } from "../../../store/dcs"
import { NoShow } from './NoShow';
import { FormattedSSRs } from '../util/formatSSRs';
import { handleCheckInChange } from '../util/checkInChange';
import checkPermissions from "../../../utils/checkPermissions";
import { InlineEdit } from "./InlineEdits";

// NOTE // formats output data for editing a phone number (to use in dcs store's editPax)
const savePhone = (pax, paxPhone) => {
  // NOTE // removing special characters
  paxPhone = paxPhone.split(' ').join('')
  paxPhone = paxPhone.split('(').join('')
  paxPhone = paxPhone.split(')').join('')
  paxPhone = paxPhone.split('-').join('')
  paxPhone = paxPhone.split('.').join('')

  let output = {
    editData: {paxNumber: pax?.PaxNumber, phoneNumber: paxPhone, ctcNumber: pax?.ctcNumber},
    rloc: pax?.PNRRefNo,
    type: 'editPhone'
  }
  return output
}

// NOTE // formats output data for editing weight (to use in dcs store's editPax)
const saveWeight = (pax, paxWeight) => {
  paxWeight = paxWeight + 'LBS'

  let output = {
    editData: {paxNumber: pax?.PaxNumber, weight: paxWeight},
    rloc: pax?.PNRRefNo,
    type: 'editWeight'
  }
  return output
}

export const PaxItem = (props) => {
  const dispatch = useDispatch()
  const {classes, modalClasses, pax, newTexts} = props;
  const airline = useSelector(state => state.entities.dcs.airline)
  const ETStatus = pax.ETStatus
  const [openRemarks, setOpenRemarks] = useState(false);
  const [openNewText, setOpenNewText] = useState(false);
  const userType = useSelector(state => state.entities.auth.userType)
  const editPaxStatus = useSelector(state => state.entities.dcs.editPaxStatus)

  // NOTE // text handling
  let formattedNewTexts = _.cloneDeep(newTexts)
  formattedNewTexts = formattedNewTexts.filter((item) => item.rloc);
  let match = false;
  let modalTexts = [];
  for (let i = 0; i < formattedNewTexts.length; i++) {
    let phone = formatPhoneNumber(formattedNewTexts[i].sender);
    if (formattedNewTexts[i].rloc.toLowerCase() === pax.PNRRefNo.toLowerCase() && phone === pax.phone) {
      match = true;
      modalTexts.push(formattedNewTexts[i]);
    }
  };

  const ids = modalTexts.map((text) => text.id);

  const handleOpenRemarks = () => {
    setOpenRemarks(true);
  };

  const handleCloseRemarks = () => {
    dispatch(resetRemarks());
    setOpenRemarks(false);
  };

  const handleOpenNewText = () => {
    setOpenNewText(true);
    dispatch(markTextsAsOld(ids))
  };

  const handleCloseNewText = () => {
    dispatch(fetchNewTexts());
    setOpenNewText(false);
  };

  return (
    <TableRow key={pax.TicketNumber} className={classes.pax}>
      {/* TODO edit remarks */}
      {/* <TableCell className={classes.tableCellLessPad} align="center">
        <div>
          <Button variant="contained" size="small" disabled={!checkPermissions(userType, airline, 'viewComment')} onClick={handleOpen
            s} style={{textTransform: 'none', fontSize: 'smaller'}}>Pax Remarks</Button>
          <Modal 
            open={openRemarks} 
            onClose={handleCloseRemarks} 
            aria-labelledby="simple-modal-title" 
            aria-describedby="simple-modal-description"
          >
            <RemarksModal pax={pax} modalClasses={modalClasses} />
          </Modal>
        </div>
      </TableCell> */}
      <TableCell className={classes.tableCellLessPad} align="center">
        <div>
          <Button variant="contained" size="small" onClick={handleOpenRemarks} disabled={!checkPermissions(userType, airline, 'viewComment')}>
            {pax.FirstName} {pax.LastName} {pax.Kal === "1" ? <Link/> : pax.GDS === "1"? <FaGoogle/> : ``}
          </Button>
          <Modal 
            open={openRemarks} 
            onClose={handleCloseRemarks} 
            aria-labelledby="simple-modal-title" 
            aria-describedby="simple-modal-description"
          >
            <RemarksModal pax={pax} closeModal={handleCloseRemarks} modalClasses={modalClasses} />
          </Modal>
        </div>
        </TableCell>
      <TableCell className={classes.tableCellLessPad} align="center">{pax.PNRRefNo}</TableCell>
      <TableCell className={classes.tableCellLessPad} align="center">{pax.PAXType + ' ' + pax.SegStatus}</TableCell>
      <TableCell className={classes.tableCellLessPad} align="center" justify="center" style={{width: '12%'}}>
        <InlineEdit pax={pax} classes={classes} initialValue={pax?.phone} label={" "} id={"phone-edit"} onSave={savePhone} editStatus={editPaxStatus.find(item => item.type === 'editPhone')} />
        {match ?
          <div>
            <Announcement className={classes.alert} onClick={handleOpenNewText} />
            <Modal
              open={openNewText} 
              onClose={handleCloseNewText} 
              aria-labelledby="simple-modal-title" 
              aria-describedby="simple-modal-description"
            >
              <NewTextModal texts={modalTexts} modalClasses={modalClasses} />
            </Modal>
          </div>
           : ''}
      </TableCell>
      <TableCell className={classes.tableCellLessPad} align="center" justify="center" style={{width: '12%'}}>
        <InlineEdit pax={pax} classes={classes} initialValue={pax?.Weight?.split('L')[0]} label={" "} id={"weight-edit"} onSave={saveWeight} editStatus={editPaxStatus.find(item => item.type === 'editWeight')} />
      </TableCell>
      <TableCell className={classes.tableCellLessPad} style={{fontSize: 'large'}} align="center">
        <FormattedSSRs pax={pax} />
      </TableCell>
      <TableCell className={classes.tableCellLessPad} align="center">{pax.FareType}</TableCell>
      {/* TODO no-show (icons: Autorenew, Backspace, Undo) */}
      <TableCell className={classes.tableCellLessPad} align="center">
        <NoShow pax={pax} status={ETStatus} dispatch={dispatch} />
      </TableCell>
      {/* TODO combine check-in-pax and no-show */}
      {/* NOTE // mui tables automatically add padding-right of 16px to the last child, so I overwrote that here in the style prop */}
      <TableCell className={classes.tableCellLessPad} style={{paddingRight: '6px'}} align="center">
        <Checkbox checked={ETStatus === "C" || ETStatus === "F"} onChange={() => {handleCheckInChange(pax, dispatch, ETStatus)}} disabled={ETStatus === "F"} />
      </TableCell>
    </TableRow>
  )
}